import { jsx as l } from "react/jsx-runtime";
import { c as u } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { r as m } from "./responsive-zaZDXrNy.js";
const p = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, y = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
};
function v(e) {
  if (e)
    return p[e];
}
function g(e) {
  if (e)
    return y[e];
}
function s(e, t) {
  return m(e, (n) => `${t}-${n}`);
}
function j(e) {
  return [
    ...s(e.padding, "p"),
    ...s(e.paddingX, "px"),
    ...s(e.paddingY, "py")
  ];
}
const $ = ({
  as: e,
  gap: t = 4,
  align: n,
  justify: r,
  padding: i,
  paddingX: a,
  paddingY: o,
  className: c,
  testId: d,
  ...f
}) => /* @__PURE__ */ l(
  e || "div",
  {
    "data-testid": d,
    className: u(
      "flex flex-col",
      v(n),
      g(r),
      s(t, "gap"),
      j({ padding: i, paddingX: a, paddingY: o }),
      c
    ),
    ...f
  }
);
export {
  $ as S,
  s as a,
  g as b,
  v as c,
  j as r
};
